import ReactECharts from "echarts-for-react";

export default function BarChartsHorizontal(data) {
  const totalItems = data?.data?.keyData?.length;
  const visibleItems = 5;

  const options = {
    title: {
      text: data.heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    color: "#9b9aff",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "2%",
      right: "5%",
      bottom: "1%",
      top: "20%",
      containLabel: true,
    },
    xAxis: {
      axisLabel: {
        show: false,
      },
      type: "value",
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: data?.data?.keyData,
      axisLabel: {
        fontSize: 14,
        width: 70,
        overflow: "truncate",
      },
      splitLine: {
        show: false,
      },
    },
    series: [
      {
        data: data?.data?.valData,
        type: "bar",
        barWidth: 15,
        itemStyle: {
          color: (params) => {
            const colorList = ["#91CC75", "#5470C6", "#EE6666", "#FAC858"];
            return colorList[params.dataIndex % colorList.length];
          },
          barBorderRadius: [0, 7, 7, 0],
        },
        label: {
          show: true,
          position: data.p,
        },
      },
    ],
    // Conditionally enable the scroll bar if there are more than 6 items
    ...(totalItems > 5 && {
      dataZoom: [
        {
          type: "slider",
          yAxisIndex: 0,
          start: 100 - (visibleItems / totalItems) * 100, // Start at top with visible items
          end: 100, // Show from top on load
          orient: "vertical",
          handleSize: 5,
          width: 10,
          showDetail: false,
          fillerColor: "#2A5775",
          backgroundColor: "#ccc",
          handleColor: "#2A5775",
          zoomOnMouseWheel: false,
          moveOnMouseMove: false,
          moveOnMouseWheel: false,
          right: 0,
          zoomLock: true,
        },
      ],
    }),
  };

  return <ReactECharts option={options} style={{ height: data.h }} />;
}
